import styled from '@emotion/styled';

import { darkGrey } from '~/styles';

export const HeroImage = styled.img`
  height: auto;
  max-width: 100%;
  object-fit: contain;
`;

export const Container = styled.div`
  width: 100%;
  background-color: ${darkGrey};
  display: flex;
  justify-content: center;
  max-height: 400px;
  position: relative;
`;

export const PlayButtonContaner = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const PlayButtonWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Backdrop = styled.div`
  background: linear-gradient(
      to bottom,
      transparent,
      rgba(0, 0, 0, 0.4) 77%,
      rgba(0, 0, 0, 0.4) 100%
    )
    100% 100%/100% 240px no-repeat transparent;
  transition: opacity 250ms cubic-bezier(0, 0.25, 0.25, 1),
    background-size 250ms cubic-bezier(0, 0.25, 0.25, 1);
  pointerevents: none;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
